import React, {useState} from 'react'

export const TodoForm = ({addTodo}) => {
    const [value, setValue] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (value) {
          // menambahkan todo
          addTodo(value);
          // menghapus form setelah submit
          setValue('');
        }
      };
  return (
    <form onSubmit={handleSubmit} className="TodoForm">
    <input type="text" value={value} onChange={(e) => setValue(e.target.value)} className="todo-input" placeholder='Apa Kegiatanmu Hari Ini ?' />
    <button type="submit" className='todo-btn'>Tambah</button>
  </form>
  )
}